<div class="container-fluid">
    <div class="d-flex flex-column flex-md-row justify-content-md-between p-1">
        <h6 class="mb-1">Planification des devoirs</h6>
        
        <div class="d-flex flex-column flex-md-row">
            <select class="mx-1 mb-1" id="" (change)="loadTask1($event)">
                <option disabled selected>Choisir la période</option>
                <option *ngFor="let p of periods" [value]="p.id">{{p.name}}</option>
            </select>
            <select class="mx-1 mb-1" id="" (change)="loadTask2($event)">
                <option disabled selected>Choisir la classe</option>
                <option *ngFor="let c of classrooms" [value]="c.classroom?.id">{{c.classroom?.name}}</option>
            </select>
        </div>

        <button (click)="add(addContent)" class="btn g-bg-danger text-white">Programmer un devoir</button>

    </div>
    <div class="form-check" *ngIf="data.length!=0">
        <input class="form-check-input" type="checkbox"  (change)="filterByProfessor($event)" id="flexCheckChecked" >
        <label class="form-check-label" for="flexCheckChecked">
          Voir uniquement mes compositions
        </label>
      </div>
    <app-task-list [data]="data2" [checkCanSet]="checkCanSet" (setStatusEmitter)="setStatus($event)" (editEmitter)="edit($event,editContent)" (deleteEmitter)="delete($event)" (confirmEmitter)="confirm($event)" [loading]="loading" ></app-task-list>
</div>

<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Programmer un devoir</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la période</label>
                <select class="mx-1 form-control" ngModel name="period_id">
                    <option selected disabled></option>
                    <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
                </select>
            </div>
           
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir le type</label>
                <select class="mx-1 form-control" ngModel name="type">
                    <option selected disabled></option>
                    <option value="Interrogation">Interrogation</option>
                    <option value="Devoir sur table">Devoir sur table</option>
                    <option value="Devoir">Devoir</option>
                </select>
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la classe</label>
                <select class="mx-1 form-control" (change)="loadCourses($event)">
                    <option selected disabled></option>
                    <option *ngFor="let pac of pacs2" [value]="pac?.id">{{pac?.classroom?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la matière</label>
                <select class="mx-1 form-control" ngModel name="pacc_id">
                    <option selected disabled></option>
                    <option *ngFor="let course of courses" [value]="course?.pivot?.id">{{course?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la salle</label>
                <select class="mx-1 form-control" ngModel name="room_id">
                    <option selected disabled></option>
                    <option *ngFor="let room of rooms" [value]="room?.id">{{room?.name}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de composition <span class="text-danger ml-2">(*)</span></label>
                <input type="datetime-local" name="programming_date" class="form-control" ngModel>
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Programmer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #editContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="update(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Programmer un devoir</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" [(ngModel)]="selected_data.name">
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la période</label>
                <select class="mx-1 form-control"  [(ngModel)]="selected_data.period_id" name="period_id">
                    <option selected disabled></option>
                    <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
                </select>
            </div>
           
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir le type</label>
                <select class="mx-1 form-control"  [(ngModel)]="selected_data.type" name="type">
                    <option selected disabled></option>
                    <option value="Interrogation">Interrogation</option>
                    <option value="Devoir sur table">Devoir sur table</option>
                    <option value="Devoir">Devoir</option>
                </select>
            </div>

            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la classe</label>
                <select class="mx-1 form-control" name="pac_id" [(ngModel)]="selected_data.pacc.pac_id" (change)="loadCourses($event)">
                    <option selected disabled></option>
                    <option *ngFor="let pac of pacs2" [value]="pac?.id">{{pac?.classroom?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la matière</label>
                <select class="mx-1 form-control"  [(ngModel)]="selected_data.pacc_id" name="pacc_id">
                    <option selected disabled></option>
                    <option *ngFor="let course of courses" [value]="course?.pivot?.id">{{course?.name}}</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="">Choisir la salle</label>
                <select class="mx-1 form-control"  [(ngModel)]="selected_data.room_id" name="room_id">
                    <option selected disabled></option>
                    <option *ngFor="let room of rooms" [value]="room?.id">{{room?.name}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de composition <span class="text-danger ml-2">(*)</span></label>
                <input type="datetime-local" name="programming_date" class="form-control"  [(ngModel)]="selected_data.programming_date">
            </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-warning" [disabled]="addForm.invalid"  >Mettre à jour <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>